import React, { useMemo } from "react";
import { useParams } from "react-router";
import { SystemConfigLayout } from "../components/SystemConfigLayout";
import { Alert } from "reactstrap";
import { CodeGroupsGeneralTab } from "./tabs/CodeGroupsGeneralTab";
import { CodeGroupsCptCodesTab } from "./tabs/CodeGroupsCptCodesTab";
import { useAdminResource } from "../utils";
import { TabbedRoutes } from "../components/TabbedRoutes";
import { Routes } from "../Routes";

const useBreadcrumbs = (pageTitle, codeGroupId) =>
  useMemo(
    () => [
      { url: Routes.codeGroups.url(), label: Routes.codeGroups.label },
      { url: Routes.codeGroup.url(codeGroupId), label: pageTitle, active: true },
    ],
    [pageTitle, codeGroupId]
  );

const useCodeGroup = (codeGroupId) => useAdminResource(`/admin/code_groups/${codeGroupId}.json`);

const TABS = [
  {
    path: "general",
    label: "General",
    Component: CodeGroupsGeneralTab,
  },
  {
    path: "cpt_codes",
    label: "CPT Codes",
    Component: CodeGroupsCptCodesTab,
  },
];

export const CodeGroupsShowPage = () => {
  const { codeGroupId } = useParams();
  const { resource: codeGroup, error, isLoading, fetch } = useCodeGroup(codeGroupId);
  const pageTitle = codeGroup?.name || `Code Group #${codeGroupId}`;
  const breadcrumbs = useBreadcrumbs(pageTitle, codeGroupId);

  return (
    <SystemConfigLayout title={pageTitle} showBreadcrumbs crumbs={breadcrumbs} loading={isLoading}>
      {error && <Alert color="danger">{error}</Alert>}

      <TabbedRoutes tabs={TABS} defaultTab={"general"} codeGroup={codeGroup} codeGroupId={codeGroupId} refresh={fetch} />
    </SystemConfigLayout>
  );
};
